import { Segmented,message, Table, Input, Button, Tooltip, Avatar, Tag } from 'antd'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { SERVER_ADDRESS } from '../../Config/Config'
import './style.css'
import { EyeFilled, SearchOutlined } from '@ant-design/icons'

const SubscribedUser = () => {
    const [users,setUsers] = useState([])
    const [filteredUsers,setFilteredUsers] = useState([])
    const [searchTerm,setSearchTerm] = useState('')
    const [selectedOption,setSelectedOption] = useState('Day Plan')
    const [loading,setLoading] = useState(false)

    useEffect(()=>{
        setLoading(true)
        setSearchTerm('')
        fetchUsers(selectedOption)
    },[selectedOption])

    const handleSearch = (value) =>{
        setSearchTerm(value)
        if(!value){
            setFilteredUsers(users)
            return
        }
        const filtered = users.filter((item)=>(
            item.name &&item.name.toLowerCase().includes(value.toLowerCase())
        ))
        setFilteredUsers(filtered)
    }

    const fetchUsers = async(flag)=>{
        try {
            const response = await axios.post(`${SERVER_ADDRESS}/api/getSubscibedUsers`,{flag})
            if(response.status === 200){
                setUsers(response.data.data)
                setFilteredUsers(response.data.data)
                setLoading(false)
            }
        } catch (error) {
            message.error({content:"Something Went Wrong !"})
            setLoading(false)
        }
    }

    const columns = [
        {
            title:"Id",
            dataIndex:"id",
            key:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Profile",
            dataIndex:"profile",
            key:"profile",
            render:(_,record)=>(
                <Avatar src={record.photo[0]} size={64} />
            )
        },
        {
            title:"Name",
            dataIndex:"name",
            key:"name"
        },
        {
            title:"Plan",
            dataIndex:"plan",
            key:"plan",
            render:(_,record)=>{
                let plan = '';
                let color = ''
                if(record.plan === 2) {
                    plan = 'Gold'
                    color='gold'
                }
                if(record.plan === 3){
                    plan = 'Silver'
                    color='blue'
                }
                if(record.plan === 4) {
                    plan = 'Diamond'
                    color='purple'
                }
                return (
                    <Tag color={color} >{plan}</Tag>
                )
            }
        },
        {
            title:"Duration",
            dataIndex:"duration",
            key:"duration",
            render:(_,record)=>(
                <Tag>{record.duration} Months</Tag>
            )
        },
        {
            title:"Purchase Date",
            dataIndex:"purchaseDate",
            key:"purchaseDate",
            render:(timestamp)=> new Date(timestamp).toLocaleDateString('en-GB')
        },
        {
            title:"Purchase End Date",
            dataIndex:"purchaseEndDate",
            key:"purchaseEndDate",
            render:(timestamp)=> new Date(timestamp).toLocaleDateString('en-GB')
        }
    ]

    const daycolumns = [
        {
            title:"Id",
            dataIndex:"id",
            key:"id",
            sorter:(a,b)=>a.id - b.id
        },
        {
            title:"Profile",
            dataIndex:"profile",
            key:"profile",
            render:(_,record)=>(
                <Avatar src={record.photo[0]} size={64} />
            )
        },
        {
            title:"Name",
            dataIndex:"name",
            key:"name"
        },
        {
            title:"Plan",
            dataIndex:"plan",
            key:"plan",
            render:(_,record)=>
            (
                <Tag color='red' >Day Plan</Tag>
            )
        },
        {
            title:"Active Plans",
            dataIndex:"activeDayPlans",
            key:"activeDayPlans"
        },
        {
            title:"First Purchase Date",
            dataIndex:"firstPurchaseDate",
            key:"firstPurchaseDate",
            render:(timestamp)=>new Date(timestamp).toLocaleDateString('en-GB')
        },
        {
            title:"Last Purchase End Date",
            dataIndex:"lastPurchaseEndDate",
            key:"lastPurchaseEndDate",
            render:(timestamp)=>new Date(timestamp).toLocaleDateString('en-GB')
        },
    ]

    const options = ["Day Plan","Subscription"]

    const renderData=()=>
    {
        if(selectedOption === 'Day Plan'){
            return (
                <Table loading={loading} dataSource={filteredUsers} rowKey={'id'} columns={daycolumns} />
            )
        }
        else if(selectedOption === 'Subscription'){
            return (
                <Table loading={loading} dataSource={filteredUsers} rowKey={'id'} columns={columns} />
            )
        }
    }

  return (
    <div style={{marginTop:"4rem"}} >
        <h4>Subscribed Users</h4>
        <div className='my-3 d-flex flex-row' style={{justifyContent:"center"}} >
            <Segmented style={{width:"50%"}} selected={selectedOption} onChange={setSelectedOption}  options={options} block />
        </div>
        <div >
            <Input placeholder='Search By name' value={searchTerm} onChange={(e)=>handleSearch(e.target.value)} style={{width:"18rem"}} suffix={<SearchOutlined />} />
        </div>
        <div className='mt-4' >
           {renderData()}
        </div>
    </div>
  )
}

export default SubscribedUser